import {FormField} from "../form-field/form-field";

export class FormFieldRating extends FormField{
    getVal(){
        return this.$value.val();
    }

    setVal(val,noEvent){
        this.$value.val(val);
        this.findMember("item").removeClass("is-selected");
        if(val){
            for(let i = val; i > 0; i--){
                this.findMember("item").filter("[data-value='"+i+"']").addClass("is-selected");
            }
        }
        this.$root.toggleClass("has-value",!!val);

        if(!noEvent){
            this.$root.trigger("formField:changeVal");
        }
    }

    emptyValue(){
        this.setVal("");
    }

    ready(){
        super.ready();
        this.$value = this.findMember("value");
        this.findMember("item").click(
            (ev) => {
                const value = $(ev.currentTarget).data("value");
                if(this.getVal()==value){
                    this.setVal("");
                }else{
                    this.setVal(value);
                }
            }
        );

        this.findMember("empty").click(
            (ev)=>{
                ev.preventDefault();
                this.emptyValue();
            }
        );

        //initial load
        if(this.$value.val()){
            this.setVal(this.$value.val(),true);
        }
    }
}
